var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 39,
    viewBox: "0 0 159 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17536 0C-0.173246 0.916078 -0.479438 5.72549 0.286041 8.01568L7.17536 34.3529C7.17536 38.0172 11.9596 38.9333 14.3518 38.9333H146.11C150.703 39.6204 152.808 34.83 153.286 32.349L158.74 8.01568C160.118 2.29019 155.678 0.286274 153.286 0H7.17536Z",
    fill: "url(#paint0_linear_458_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_12",
    x1: 51,
    y1: -0.0000126958,
    x2: 129,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F84C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector-4.22fcf70846365ac29063b48cd2c75628.svg";
export { ForwardRef as ReactComponent };